import { IDirection } from '@sanlam-glacier/app-common/components';
import {
  NaturalPersonDetails,
  LegalEntityDetails
} from 'modules/dashboard/types/widgets/widget.interfaces';
import { ReactNode } from 'react';

export type ClientType = {
  id: number;
  clientName: string;
  clientSurname: string;
  investmentType: string;
};

export type EventType = 'birthday' | 'holiday' | 'event';

export type PersonalDetails = NaturalPersonDetails | LegalEntityDetails;

export type BankAccountCardProps = {
  logo: string;
  bankName: string;
  accountHolder: string;
  accountNumber: string;
  accountType: string;
  verified: boolean;
};

export enum WidgetState {
  Loading,
  Error,
  Success
}

export type WidgetContextType = {
  setReloadHandler: React.Dispatch<React.SetStateAction<(() => void) | null>>;
  setWidgetState: React.Dispatch<React.SetStateAction<WidgetState>>;
};

export interface UseSetWidgetStatusProps {
  isFetching: boolean;
  isError: boolean;
  isSuccess: boolean;
  context: {
    setWidgetState: (value: WidgetState) => void;
  } | null;
}

export type ToDoListTableHeaderConfig<T = unknown> = (
  | {
      label: string;
      renderCellContent?: never;
    }
  | {
      renderCellContent: () => ReactNode;
      label?: never;
    }
) & {
  key?: keyof T | 'actions';
  allowSorting?: boolean;
  align?: 'left' | 'right';
  className?: string;
  direction: IDirection;
};
